import { useEffect, useState } from "react";
import tradeBlockDataStore from "@/store/tradeBlockDataStore";
import { setTradeSettingsToOneWayDirectionShown } from "@/store/tradeSettingsStoreACTIONS";
import { blocksContainNPV } from "./unwindSideRule";

// LQC-2271 - an NPV block forces One-Way + Direction SHOW and locks Side
// (see unwindSideRule). Shared by the Edit Panel grid (CPSettingsGrid) and the
// Trade Settings sidebar so both react to the same block data the same way.
// Returns whether this trade currently holds an NPV block.
export function useNPVSideLock(esid: string): boolean {
  const [npvInTrade, setNpvInTrade] = useState(false);
  const allBlockInfo = tradeBlockDataStore((state) => state.tradeBlockData);

  useEffect(() => {
    const thisBlockInfo = allBlockInfo.find((trade) => trade.esid == esid);
    if (!thisBlockInfo) return;
    if (!thisBlockInfo.blocks || thisBlockInfo.blocks.length === 0) {
      setNpvInTrade(false);
      return;
    }
    const containsNPV = blocksContainNPV(thisBlockInfo.blocks);
    setNpvInTrade(containsNPV);
    if (containsNPV) {
      setTradeSettingsToOneWayDirectionShown({ esid });
    }
  }, [allBlockInfo, esid]);

  return npvInTrade;
}

export default useNPVSideLock;
